import { render, staticRenderFns } from "./rHandsontable.vue?vue&type=template&id=48e35cc9&"
import script from "./rHandsontable.vue?vue&type=script&lang=js&"
export * from "./rHandsontable.vue?vue&type=script&lang=js&"
import style0 from "./rHandsontable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports